/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exlusive_trees: NonNullable<unknown> }} Daily_Paywall_Tree_TitleInputs */

const en_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Glow Up with ${i?.exlusive_trees}`)
};

const ar_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تألق مع ${i?.exlusive_trees}`)
};

const de_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Glow Up mit ${i?.exlusive_trees}`)
};

const es_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Brilla con los ${i?.exlusive_trees}`)
};

const fr_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sublimez votre Forêt avec ${i?.exlusive_trees}`)
};

const it_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Illuminati con ${i?.exlusive_trees}`)
};

const ja_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exlusive_trees}でForestを彩ろう`)
};

const ko_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exlusive_trees}, 정변의 도우미`)
};

const pt_br_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vivifique sua floresta com ${i?.exlusive_trees}`)
};

const ru_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сияйте вместе с ${i?.exlusive_trees}`)
};

const th_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เปล่งประกายไปกับ${i?.exlusive_trees}`)
};

const tr_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exlusive_trees} ile Işılda`)
};

const zh_cn_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 ${i?.exlusive_trees}
打造绝美森林`)
};

const zh_tw_daily_paywall_tree_title = /** @type {(inputs: Daily_Paywall_Tree_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 ${i?.exlusive_trees}
打造絕美森林`)
};

/**
* | output |
* | --- |
* | "Glow Up with {exlusive_trees}" |
*
* @param {Daily_Paywall_Tree_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_tree_title = /** @type {((inputs: Daily_Paywall_Tree_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Tree_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_tree_title(inputs)
	if (locale === "ar") return ar_daily_paywall_tree_title(inputs)
	if (locale === "de") return de_daily_paywall_tree_title(inputs)
	if (locale === "es") return es_daily_paywall_tree_title(inputs)
	if (locale === "fr") return fr_daily_paywall_tree_title(inputs)
	if (locale === "it") return it_daily_paywall_tree_title(inputs)
	if (locale === "ja") return ja_daily_paywall_tree_title(inputs)
	if (locale === "ko") return ko_daily_paywall_tree_title(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_tree_title(inputs)
	if (locale === "ru") return ru_daily_paywall_tree_title(inputs)
	if (locale === "th") return th_daily_paywall_tree_title(inputs)
	if (locale === "tr") return tr_daily_paywall_tree_title(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_tree_title(inputs)
	return zh_tw_daily_paywall_tree_title(inputs)
});